import React from 'react';

import fetch from '../../fetch';

import moment from 'moment';

const DataGrid = {
    selections: [],
    resultStateSelections: [],
    refresh: function () {

    }
}

const headers = [
    { type: 'selection' },
    { key: '$index', label: '序号', width: 40 },
    { key: 'classTime', label: '日期', width: 100, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
    { key: 'lessonNum', label: '节次', width: 60 },
    { key: 'lessonAddress', label: '教室', width: 150 },
    { key: 'weekName', label: '星期', width: 60 },
    { key: 'classWeek', label: '听课周次', width: 80, render: (value) => value ? `第${value}周` : "" },
];


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('course/plan/selection/task/attendLectureList', Object.assign(defaultsParams, keywords))
        .then(response => {
            return {
                data: response.payload.data,
                meta: response.payload.meta
            };
        })
        .then(response => (Object.assign({
            result: (response.data.dataList || []).map(item => {
                return Object.assign(item, {
                    backFlag: response.backFlag,
                })
            }),
            selects: (response.data.dataList || []).map(d => ({
                value: d.id,
                Key: d.id,
                checked: false
            })),
            meta: response.meta,
            checked: false,
            total: response.data.total,
            pageIndex: response.data.pageNum,
            pageSize: response.data.pageSize,
            notify: (response.data.dataList || []).length ? '' : '暂无数据...'
        })));
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onResultStateSelect = (ids) => {
    DataGrid.resultStateSelections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getResultStateSelect = () => {
    return DataGrid.resultStateSelections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'eval/result' + url;
};

const getSelection = () => {
    return DataGrid.selections;
}

/**
 * 数据导出
 * @method exportList
 * @param {object} [keywords]
 * @return {promise}
 */
 const attendExport = (keywords) => {
    return fetch.download('course/plan/selection/task/attendExport', keywords, "听课任务信息数据导出.xls")
}



export default {
    querySearch,
    headers,
    onSelect,
    setRefresh,
    redirect,
    getSelection,
    onResultStateSelect,
    getResultStateSelect,
    attendExport
}